<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">Users in Company/Role</h1>
                <div class="Options">
                    <button v-on:click.stop="close()">Close</button>
                </div>
            </div>
            <div class="modalBody" v-if="Role === null || Users === null">
                <p><loading-indicator /> Loading Role/Users...</p>
            </div>
            <div class="modalBody" v-if="Role !== null && Users !== null">
                <!-- && Logos !== null">-->
                <h2>Users in {{CompanyName}} (<i v-if="RoleName === null">All</i><span v-else>{{RoleName}}</span>)</h2>
                <ul>
                    <li v-for="user in Users" :key="user.id">{{user.lastName}}, {{user.firstName}} (<a :href="'mailto:' + user.email">{{user.email}}</a>) - <a :href="'/?userId=' + user.id">Edit</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import LoadingIndicator from './LoadingIndicator.vue';

    import $ from 'jquery';

    export default {
        name: 'UsersInCompany',
        components: {
            LoadingIndicator
        },
        props: ["roleId"],
        data: function () {
            return {
                Role: null,
                Users: null
            }
        },
        computed: {
            "CompanyName": {
                get: function () {
                    if (this.Role == null || this.Role.name == null)
                        return null;
                    return this.Role.name.split('~')[0];
                },
                set: function (value) {
                    if (this.RoleName == null)
                        this.Role.name = value;
                    else
                        this.Role.name = value + '~' + this.RoleName;
                }
            },
            "RoleName": {
                get: function () {
                    if (this.Role == null || this.Role.name == null || this.Role.name.split('~').length == 1)
                        return null;
                    else
                        return this.Role.name.split('~')[1];
                },
                set: function (value) {
                    this.Role.name = this.CompanyName + '~' + value;
                }

            }
        },
        created: function () {
            var myComponent = this;
              $.ajax({
                type: 'GET',
                url: 'Roles/' + this.roleId,
                dataType: 'json',
                success: function (data) {
                    myComponent.Role = data;
                }
            });
            $.ajax({
                type: 'GET',
                url: 'LocalUsers/ByRole/' + this.roleId,
                dataType: 'json',
                success: function (data) {
                    myComponent.Users = data;
                }
            });
        },
        methods: {
            "close": function () {
                this.$emit('update:roleId', null);
            },
        },
    }
</script>